package com.kinoshazam.screens.main.medium

import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.cells.cellItem.CellItem
import com.kinoshazam.uiKit.components.cells.cellItem.CellItemState
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.theme.BoldMedium
import com.kinoshazam.uiKit.theme.UiKitTheme
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.cartoons
import kinoshazam.resources.generated.resources.popular_cartoons
import kinoshazam.resources.generated.resources.popular_tv_cartoons
import kinoshazam.resources.generated.resources.tv_show_cartoon
import kinoshazam.resources.generated.resources.which_watch
import org.jetbrains.compose.resources.stringResource
import presentation.screens.allVideos.AllVideosState.ScreenType.Cartoons
import presentation.screens.main.MainMVIAction
import presentation.screens.main.MainState

@OptIn(ExperimentalFoundationApi::class)
@Composable
fun ColumnScope.CartoonLargeContent(
    state: MainState,
    onAction: (MainMVIAction) -> Unit,
) {
    val cartoonsWatchAllTitle = stringResource(Res.string.popular_cartoons)
    val tvCartoonsWatchAllTitle = stringResource(Res.string.popular_tv_cartoons)

    Spacer(modifier = Modifier.weight(1f))

    CellItem(
        modifier = Modifier.wrapContentHeight(),
        state = CellItemState(
            title = TextLabelState(
                textAlign = TextAlign.Center,
                text = buildAnnotatedString {
                    withStyle(
                        style = SpanStyle(
                            color = UiKitTheme.colors.color_2,
                            fontWeight = BoldMedium.fontWeight
                        )
                    ) {
                        append("${stringResource(Res.string.cartoons)},")
                    }
                    withStyle(
                        style = SpanStyle(
                            color = UiKitTheme.colors.color_2,
                        )
                    ) {
                        append(" ${stringResource(Res.string.which_watch)}")
                    }
                }
            )
        )
    )

    VideosCarouselWithWatchAll(
        videos = state.cartoonsVideos,
        videoClicked = { isTvShow, id ->
            if (isTvShow) {
                onAction(MainMVIAction.OnTvShowClicked(id))
            } else {
                onAction(MainMVIAction.OnDetailsClicked(id))
            }
        },
        onWatchAll = {
            onAction(
                MainMVIAction.OnAllVideoClicked(
                    screenType = Cartoons,
                    title = cartoonsWatchAllTitle,
                    isSerial = false,
                )
            )
        },
    )

    Spacer(modifier = Modifier.weight(1f))

    CellItem(
        modifier = Modifier.wrapContentHeight(),
        state = CellItemState(
            title = TextLabelState(
                textAlign = TextAlign.Center,
                text = buildAnnotatedString {
                    withStyle(
                        style = SpanStyle(
                            color = UiKitTheme.colors.color_2,
                            fontWeight = BoldMedium.fontWeight
                        )
                    ) {
                        append("${stringResource(Res.string.tv_show_cartoon)},")
                    }
                    withStyle(
                        style = SpanStyle(
                            color = UiKitTheme.colors.color_2,
                        )
                    ) {
                        append(" ${stringResource(Res.string.which_watch)}")
                    }
                }
            )
        )
    )

    VideosCarouselWithWatchAll(
        videos = state.cartoonsTvVideos,
        videoClicked = { isTvShow, id ->
            if (isTvShow) {
                onAction(MainMVIAction.OnTvShowClicked(id))
            } else {
                onAction(MainMVIAction.OnDetailsClicked(id))
            }
        },
        onWatchAll = {
            onAction(
                MainMVIAction.OnAllVideoClicked(
                    screenType = Cartoons,
                    title = tvCartoonsWatchAllTitle,
                    isSerial = true,
                )
            )
        },
    )

    Spacer(modifier = Modifier.weight(1f))
}
